import { render } from "./SidebarLink.vue?vue&type=template&id=03cab1a0&scoped=true"
import script from "./SidebarLink.vue?vue&type=script&lang=js"
export * from "./SidebarLink.vue?vue&type=script&lang=js"

import "./SidebarLink.vue?vue&type=style&index=0&id=03cab1a0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src299072838/src/goku/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03cab1a0"]])

export default __exports__